/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const BatteryBolt = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M2 13h5.6l-.4 2H1.5C.7 15 0 14.3 0 13.5v-7C0 5.7.7 5 1.5 5h3.6l-.2 2H2v6zm11.4-5h-2.9l.9-4.2c.1-.4-.2-.8-.6-.8H7.4c-.3 0-.6.2-.6.6L6 10.2c0 .4.2.8.6.8h3l-1.2 5.2c-.1.4.2.8.6.8.2 0 .4-.1.5-.3L13.9 9c.2-.5 0-1-.5-1zm5.8-1H19v-.5c0-.8-.7-1.5-1.5-1.5h-4.8l-.3 1.5h1c.5 0 1 .2 1.3.5H17v2h1v2h-1v2h-3.7l-1.1 2h5.3c.8 0 1.5-.7 1.5-1.5V13h.2c.4 0 .8-.3.8-.8V7.8c0-.5-.3-.8-.8-.8z" />
  </svg>
);

export default extendIcon(BatteryBolt);
